const  getFileReducer = state => state.filesAttachmentsReducer;
export const getFilesAttachment = state =>  getFileReducer(state).attachmentsfiles;
export const getIsFilesFetching = state => getFileReducer(state).isFetchingFiles;
export const getDownloadingAllAttachments = state => getFileReducer(state).downloadingAttachment;